import { CART_ERROR_ID } from 'core/middlewares/effects/orchestrator/workflows/error-handling';

import type { Cart, RootState } from 'core';

type Item = Cart['data']['items'][number];

export const cartItemUpdateError = (action: any, prevState: RootState) => {
  const { meta } = action;
  const { productCode } = meta.payload;

  const product = action.payload?.items?.find(
    (item: Item) => item.productCode === productCode,
  ) as Item;

  const listName = meta.payload?.itemListName ?? product?.itemListName ?? '';

  const previousQuantity =
    prevState.cart.data.items.find((item) => item.productCode === productCode)?.quantity ?? 0;
  const actualQuantity = action.meta.payload.quantity as number;

  if (previousQuantity > actualQuantity) {
    return {
      event: 'analytics-event', // always this event name
      event_parameters: {
        event_name: `interaction_${listName}`,
        cd_interaction_detail: `toast:erro-erro-remover-item`,
        cd_quantidade_itens_solicitados: action.meta.payload.quantity,
      },
    };
  }

  if (action.error?.response?.errorId === CART_ERROR_ID.PRODUCT_QUOTA_EXCEEDED) {
    return {
      event: 'analytics-event', // always this event name
      event_parameters: {
        event_name: `interaction_${listName}`,
        cd_interaction_detail: `toast:erro-cota-zerada`,
        cd_quantidade_itens_solicitados: action.meta.payload.quantity,
      },
    };
  }

  if (action.error?.response?.errorId === CART_ERROR_ID.UNCOMMITTED_ITEM_API_EXCEPTION) {
    return {
      event: 'analytics-event', // always this event name
      event_parameters: {
        event_name: `interaction_${listName}`,
        cd_interaction_detail: `toast:erro-estoque-indisponivel`,
        cd_quantidade_itens_solicitados: action.meta.payload.quantity,
      },
    };
  }

  return {
    event: 'analytics-event', // always this event name
    event_parameters: {
      event_name: `interaction_${listName}`,
      cd_interaction_detail: `toast:erro-erro-generico`,
      cd_quantidade_itens_solicitados: action.meta.payload.quantity,
    },
  };
};
